import { Injectable, EventEmitter } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { BaseResponsiveState } from '../classes/responsive-state';
import { BreakpointService } from './breakpoint.service';

@Injectable({
	providedIn: 'root'
})
export class PopupService extends BaseResponsiveState {
	messagePopupWidth = '';
	popupWidth = '';
	popupHeight = '';
	heightType = '';

	private dataSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);
	buttonClicked: EventEmitter<any> = new EventEmitter<any>();

	constructor(public override breakpointService: BreakpointService) {
		super(breakpointService);
		this.setResponsiveState();
		this.setWidth();
	}

	emitButtonClicked(): void {
		this.buttonClicked.emit();
	}

	setData(data: any): void {
		this.dataSubject.next(data);
	}

	getData(): BehaviorSubject<any> {
		return this.dataSubject;
	}

	setWidth() {
		if (this.isXSmall || this.isSmall || this.isMedium) {
			this.messagePopupWidth = '70vw';
			this.popupWidth = '100vw';
			this.popupHeight = '100vh';
			this.heightType = 'height';
		} else {
			this.messagePopupWidth = '25vw';
			this.popupWidth = '60vw';
			this.popupHeight = '90vh';
			this.heightType = 'maxHeight';
		}
	}
}
